import { STYLE } from './portableEditor';

/**
 * Heading configuration for portable editor
 * Single source of truth for all heading types
 */
export interface HeadingConfig {
  title: string;
  value: string;
  tag: string;
  className?: string;
}

export const HEADING_CONFIGS: HeadingConfig[] = [
  { title: 'H2', value: 'h2', tag: 'h2' },
  { title: 'H2 Highlight', value: STYLE.H2_HIGHLIGHT, tag: 'h2', className: 'h2-highlight' },
  { title: 'H3', value: 'h3', tag: 'h3' },
  { title: 'H3 Tenon', value: STYLE.H3_TENON, tag: 'h2', className: 'h3-tenon' },
  { title: 'H4', value: 'h4', tag: 'h4' },
  { title: 'H5', value: 'h5', tag: 'h5' },
  { title: 'H5 Tenon', value: STYLE.H5_TENON, tag: 'h3', className: 'h5-tenon' },
  { title: 'H6', value: 'h6', tag: 'h6' },
];

